<div class="w-full h-full bg-white p-4 relative z-50">
  <button
    class="absolute bg-opacity-25 rounded-full flex flex-col items-center justify-center p-2 top-8 right-8 z-50 bg-white"
    (click)="close()"
  >
    <ng-icon name="heroXMark" size="24px"></ng-icon>
  </button>
  <app-image-slider
    [items]="items()"
    class="relative w-full h-full"
    [imageSize]="2000"
    [fullScreen]="true"
    [currentIndex]="currentIndex"
  ></app-image-slider>
</div>
